import * as S from '../Terms.styled';

export default function PrivacyPolicy() {
  return (
    <S.Container>
      <S.Title>Privacy Policy</S.Title>
      <S.Desc>
        Nation A (also referred to as “Company,” “we,” “us,” or “our”) ranks the
        personal data protection for data subjects as a top priority in
        compliance with the Personal Information Protection Act and other
        relevant laws, in order to protect the freedom and rights of data
        subjects, and ensure legitimate processing and safe management of
        personal information. In accordance with Article 30 of the Personal
        Information Protection Act, the Company will provide data subjects (also
        referred to as “you” or “your”) in this Privacy Policy to with detailed
        information on how and where we use your personal data that we have
        collected, which measures are taken to protect your privacy and how you
        resolve your grievances.
      </S.Desc>

      <S.Article>
        <S.ArticleTitle>
          Article 1. Purpose for Processing Personal Information
        </S.ArticleTitle>
        <S.ArticleContent>
          <p>
            ① We process personal information for the following purposes. The
            personal information processed will not be used for any purpose
            other than the followings, and if the purpose of processing is
            modified or altered, the Company will take necessary measures such
            as obtaining the consent from data subjects.
          </p>

          <S.Table>
            <thead>
              <tr>
                <th>Purpose</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  Signing up and member management
                  <br />
                  Service delivery
                </td>
                <td>
                  To confirm your intent to sign up, identify and authenticate
                  you for membership, prevent fraudulent use of our services,
                  verify your age, maintain and limit your membership, and
                  provide you with various notices and communications
                </td>
              </tr>
              <tr>
                <td>Marketing campaigns and promotions</td>
                <td>
                  To provide you with event information, promotional
                  information, opportunities of participation, and marketing
                  information
                </td>
              </tr>
            </tbody>
          </S.Table>

          <p>
            ② In principle, the Company processes personal information with the
            consent of the data subject, provided that, however, in any of the
            following cases, personal information may be collected without the
            consent and used within the scope of the intended purposes:
          </p>
          <S.SubSection>
            <ol className='list'>
              <li>
                1. To the extent specifically required by the applicable laws
                and regulations;
              </li>
              <li>
                2. When personal information is necessary for the fulfillment of
                the Service Contract, and it is clearly difficult to obtain the
                consent for financial or technical reasons; or
              </li>
              <li>
                3. When it is required for settlement of charges for Services.
              </li>
            </ol>
          </S.SubSection>
        </S.ArticleContent>
      </S.Article>

      <S.Article>
        <S.ArticleTitle>
          Article 2. Information Collected and Retention Period
        </S.ArticleTitle>
        <S.ArticleContent>
          <p>
            The personal information processed by the Company are as follows.
            Company processes and retains personal information within the period
            of use and retention agreed upon when collecting personal
            information of the data subject or within the period set forth in
            the relevant laws and regulations.
          </p>
          <S.Table>
            <thead>
              <tr>
                <th>Intended Purpose</th>
                <th>Information Processed</th>
                <th>Retention and Usage Period</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  Signing up and member management
                  <br />
                  Service delivery
                </td>
                <td>
                  Name, email account, password, phone number, occupation,
                  gender, date of birth, and credentials for easy sign-in
                </td>
                <td>
                  <div>
                    <div>Until the data subject stops using the Services</div>
                    <div>
                      However, (1) in the event of an ongoing investigation in
                      violation of relevant laws and regulations, the records
                      shall be retained until the end of such proceedings; (2)
                      in the event of a debt or liability due to the use of the
                      Services, the records shall be retained until the
                      settlement of such debt or liability, and (3) records of
                      displayed advertisements shall be retained for at least
                      six months in accordance with the Electronic Commerce Act.
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  Personalized advertising and marketing, service improvements,
                  and new service development
                </td>
                <td>Same as above</td>
                <td>
                  <div>
                    <div>Until the data subject stops using the Services</div>
                    <div>
                      However, (1) in the event of an ongoing investigation in
                      violation of relevant laws and regulations, the records
                      shall be retained until the end of such proceedings; (2)
                      in the event of a debt or liability due to the use of the
                      Services, the records shall be retained until the
                      settlement of such debt or liability, and (3) records of
                      displayed advertisements shall be retained for at least
                      six months in accordance with the Electronic Commerce Act.
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </S.Table>
        </S.ArticleContent>
      </S.Article>

      <S.Article>
        <S.ArticleTitle>Article 3. Disclosure to Third Parties</S.ArticleTitle>
        <S.ArticleContent>
          <p>
            ① The Company will not provide personal information of data subjects
            to third parties in principle, except when the data subjects have
            been informed the details of disclosure to third parties and given
            the prior consent, including but not limited to the person to whom
            the personal information is provided, the purpose for which the
            personal information will be used, the types of personal information
            provided, the period of retention and use, the right to refuse
            consent, and the disadvantages when they refuse to give the consent.
          </p>
          <p>
            ② For the provisions of the preceding Paragraph 1, the Company will
            not provide personal information to a third party outside the scope
            of the purpose for which it has been collected, except when the data
            subjects have been informed the details of disclosure to third
            parties for purposes beyond the intended purposes and given the
            prior consent, including but not limited to the person to whom the
            personal information is provided, the purpose for which the personal
            information will be used, the types of personal information
            provided, the period of retention and use, the right to refuse
            consent, and the disadvantages when they refuse to give the consent.
          </p>
          <p>
            ③ Notwithstanding the foregoing, we may provide the information to
            third parties without the consent of the data subject in any of the
            following cases:
          </p>
          <S.SubSection>
            <ol className='list'>
              <li>
                1. To the extent specifically required by the applicable laws
                and regulations;
              </li>
              <li>
                2. When the government and public agencies, law enforcement, and
                courts request to disclose the personal information in
                accordance with the procedures and methods stipulated by
                applicable laws;
              </li>
              <li>
                3. When providing anonymized information for statistics,
                scientific research or public records; or
              </li>
              <li>
                4. When it is required for settlement of charges for Services.
              </li>
            </ol>
          </S.SubSection>
        </S.ArticleContent>
      </S.Article>

      <S.Article>
        <S.ArticleTitle>Article 4. Rights of Data Subject</S.ArticleTitle>
        <S.ArticleContent>
          <p>
            ① As a data subject, you may have and exercise any of the following
            rights and choices regarding the Company’s processing activities for
            your persona information:
          </p>
          <S.SubSection>
            <ol className='list'>
              <li>
                1. Right to access, provided that, however, the Company may
                limit or refuse your request for access: when access is
                prohibited or restricted by the relevant laws; when it is likely
                to harm the life and body of another person; or when it is
                likely to unreasonably infringe on the property and other
                interests of another person.
              </li>
              <li>
                2. Right to edit or remove, provided that, however, you are
                unable to demand removal if the relevant laws and regulations
                specify that the personal information should collected.
              </li>
              <li>
                3. Right to restriction of processing, provided that, however,
                the Company may refuse to accept your request: to the extent
                specifically required by the applicable laws and regulations;
                when it is unavoidable to comply with legal obligations; when it
                is likely to harm the life, body, or property of another person;
                when it is likely to unreasonably infringe on the property and
                other interests of another person; when the data subject has not
                clearly expressed their intention to terminate the contract and
                we cannot provide the services contracted with the data subject
                without processing the personal information.
              </li>
              <li>4. Right to withdraw consent.</li>
            </ol>
          </S.SubSection>
          <p>
            ② The data subject may exercise the rights set forth in the
            preceding Paragraph 1 via the bulletin on the platform (Nolsim)
            operated by the Company or via an email to the Company, and the
            Company will promptly address their request.
          </p>
          <p>
            ③ If the data subject requests the correction of errors or removal
            of personal information, the Company will not use or provide the
            personal information until the correction or removal is completed.
            If incorrect personal information is provided to any third parties,
            the Company will immediately notify the third parties so that it can
            be corrected or removed.
          </p>
          <p>
            ④ The legal representative of the data subject or a person
            authorized by the data subject may exercise the rights set forth in
            the preceding Paragraph 1 on behalf of the data subject if they
            submit a written evidence of their authority, such as a power of
            attorney, to the Company.
          </p>
        </S.ArticleContent>
      </S.Article>

      <S.Article>
        <S.ArticleTitle>
          Article 5. Destruction of Personal Information
        </S.ArticleTitle>
        <S.ArticleContent>
          <p>
            ① Company shall immediately destroy the personal information of the
            data subject when it becomes unnecessary, for example, when the
            intended purposes are achieved, the period of retention and use is
            expired, or the business is terminated.
          </p>
          <p>
            ② Notwithstanding the preceding Paragraph 1, if the Company is
            required to preserve such personal information as required by the
            relevant laws and regulations, we will store and manage such
            personal information separately from other personal information.
          </p>
          <p>
            ③ The procedures and method for destroying personal information are
            as follows.
          </p>
          <S.SubSection>
            <ol className='list'>
              <li>
                1. Destruction procedure: We select the personal information for
                which the reason for destruction has occurred and destroy such
                information with the approval of the Chief Privacy Officer.
              </li>
              <li>
                2. Method of destruction: Personal information stored as an
                electronic file is destroyed using a technical or physical
                method such that records cannot be reproduced, and personal
                information printed on paper is shredded, destroyed by
                incineration, masked or punched.
              </li>
            </ol>
          </S.SubSection>
        </S.ArticleContent>
      </S.Article>

      <S.Article>
        <S.ArticleTitle>Article 6. Security</S.ArticleTitle>
        <S.ArticleContent>
          <p>
            Company takes the following measures to prevent the loss, theft,
            leakage, tampering, falsification or damage of personal information
            of data subjects.
          </p>
          <S.SubSection>
            <ol className='list'>
              <li>
                1. Establishment and implementation of internal protection
                plans, operation of a dedicated organization, periodic employee
                training programs;
              </li>
              <li>2. Restricted access control and security programs;</li>
              <li>
                3. Physical restrictions such as locked archive and entrance
                control
              </li>
            </ol>
          </S.SubSection>
        </S.ArticleContent>
      </S.Article>

      <S.Article>
        <S.ArticleTitle>Article 7. Chief Privacy Officer</S.ArticleTitle>
        <S.ArticleContent>
          <p>
            We have designated the department in charge and a person who acts as
            a Chief Privacy Officer to take responsibility of protecting
            personal information, resolving any related complaints, providing
            damage relief, and accepting a request to access.
          </p>
          <S.SubSection>
            <ol className='list'>
              <li>1. Name: Suyeon Yoo</li>
              <li>2. Title/Position: CEO</li>
              <li>
                3. Contact Info (email or phone number): sy.yoo@nation-a.com
              </li>
            </ol>
          </S.SubSection>
        </S.ArticleContent>
      </S.Article>

      <S.Article>
        <S.ArticleTitle>Article 8. Remedies for Infringement</S.ArticleTitle>
        <S.ArticleContent>
          <p>
            If you have a complaint regarding your personal information, such as
            a privacy infringement, arising out of the services you have used
            from the Company, however if you cannot be satisfied with our
            response or need to consult, you can contact the following
            institutions which separate entities from the Company.
          </p>
          <S.Table>
            <thead>
              <tr>
                <th>Relevant Institution</th>
                <th>Address</th>
                <th>Contact Info</th>
                <th>Website</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  Personal Information Infringement Report Center
                  <br />
                  (under the Korea Internet & Security Agency)
                </td>
                <td>9 Jinheung-gil, Naju-si, Jeollanam-do (Bitgaram-dong)</td>
                <td>Call at 118</td>
                <td>
                  <a href='http://privacy.kisa.or.kr'>privacy.kisa.or.kr</a>
                </td>
              </tr>
              <tr>
                <td>Personal Information Protection Commission</td>
                <td>12 Floor 209 Sejong-daero, Jongno-gu, Seoul</td>
                <td>Call at 1833-6972</td>
                <td>
                  <a href='http://www.kopico.go.kr'>www.kopico.go.kr</a>
                </td>
              </tr>
              <tr>
                <td>
                  Cyber Crime Investigation Unit, Supreme Prosecutor’s Office
                </td>
                <td />
                <td>Call at 1301</td>
                <td>
                  <a href='http://www.spo.go.kr'>www.spo.go.kr</a>
                </td>
              </tr>
              <tr>
                <td>ECRM, National Police Agency</td>
                <td />
                <td>Call at 182</td>
                <td>
                  <a href='http://ecrm.cyber.go.kr'>ecrm.cyber.go.kr</a>
                </td>
              </tr>
            </tbody>
          </S.Table>
        </S.ArticleContent>
      </S.Article>

      <S.Article>
        <S.ArticleTitle>
          Article 9. Enforcement of the Privacy Policy
        </S.ArticleTitle>
        <S.ArticleContent>
          <p>This Privacy Policy shall be effective as of May --, 2024. </p>
        </S.ArticleContent>
      </S.Article>
    </S.Container>
  );
}
